export default __webpack_public_path__ + "static/media/advantage-2.d602ad9d.png";